
import React from 'react';
import MainLayout from '../components/Layout/MainLayout';
import NoticeBoard from '../components/NoticeBoard';

const Notices: React.FC = () => {
  return (
    <MainLayout title="Notice Board">
      <div className="p-4">
        <NoticeBoard />
      </div>
    </MainLayout>
  );
};

export default Notices;
